import { temporaryNotificationDomainStore } from '../temporary-store/store';
export const getNotifications = () => temporaryNotificationDomainStore.data.notifications;
